<template>
  <!-- MODAL EDIT -->
  <b-modal
    :id="'EquipmentEdit'+idData"
    ref="my-modal"
    no-close-on-backdrop
    no-close-on-esc
    title="แก้ไขอุปกรณ์"
    dialog-class="modal-custom"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <validation-observer ref="simpleRules">
      <b-row>
        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-groupgetData
            label="Host name (DRR-xxx) (ภาษาอังกฤษเท่านั้น)"
          >
            <validation-provider
              #default="{ errors }"
              name="hostname"
              rules="required|hostname"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="hostname"
                  v-model="editData.hostname"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="รายละเอียดจุดติดตั้ง"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <b-col
          v-if="dropdownLocation.length > 1"
          lg="6"
          md="12"
        >
          <b-form-group
            label="ใช้ในจุดติดตั้งที่"
          >
            <validation-provider
              #default="{ errors }"
              name="location id"
              rules="required"
            >
              <v-select
                v-model="editData.location_id"
                :reduce="dropdownLocation => dropdownLocation.location_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="location_name"
                :options="dropdownLocation"
                placeholder="ใช้ในจุดติดตั้งที่..."
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- <b-col
          lg="6"
          md="12"
        >
          <b-form-group
            label="ประเภทงาน"
          >
            <validation-provider
              #default="{ errors }"
              name="AnalyticType"
              rules="required"
            >
              <v-select
                v-model="selectAnalyticType"
                :reduce="dropdownAnalytic => dropdownAnalytic.type_name"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="thai_name"
                :options="dropdownAnalytic"
                placeholder="เลือกประเภทงาน..."
                transition=""
                @input="addAnalyticType()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <!-- <b-col
          v-if="editData.group_name === 'CCTV'"
          lg="6"
          md="6"
        >
          <b-form-group
            label="การใช้งาน"
          >
            <validation-provider
              #default="{ errors }"
              name="eq_function"
              rules="required"
            >
              <v-select
                v-model="editData.eq_function"
                :reduce="dropdownFunction => dropdownFunction.eq_function"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="eq_function"
                :options="dropdownFunctions"
                placeholder="เลือกการใช้งาน..."
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="IPADDRESS"
          >
            <validation-provider
              #default="{ errors }"
              name="ipaddress"
              rules="required|ip_address"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="ipaddress"
                  v-model="editData.ipaddress"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="xxx.xxx.xxx.xxx"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <!-- <b-col
          v-show="editData.group_name == 'Desktop PC' || editData.group_name == 'Industrial PC' || editData.group_name == 'Industrial PC'
            || editData.group_name == 'Tablet PC' || editData.group_name == 'Workstation PC'"
          md="12"
          lg="6"
        >
          <b-form-group
            label="ZT Ipaddress"
          >
            <validation-provider
              #default="{ errors }"
              name="ZT_ipaddress"
              :rules="editData.group_name == 'Desktop PC' || editData.group_name == 'Industrial PC' || editData.group_name == 'Industrial PC'
                || editData.group_name == 'Tablet PC' || editData.group_name == 'Workstation PC' ? 'required|ZT_Ipaddress' : ''"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="zt_ipaddress"
                  v-model="editData.zt_ipaddress"
                  type="text"
                  placeholder="xxx.xxx.xxx.xxx"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="Brand"
          >
            <validation-provider
              #default="{ errors }"
              name="brand"
              rules="required"
            >
              <v-select
                v-model="editData.brand"
                :reduce="brand => brand.brand"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                taggable
                required
                label="brand"
                :options="dropdownBrand"
                placeholder="เลือกยี่ห้ออุปกรณ์..."
                transition=""
                :disabled="disabledBrand"
                @input="optionModel()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="Model"
          >
            <validation-provider
              #default="{ errors }"
              name="model"
              rules="required"
            >
              <v-select
                v-model="editData.model"
                :reduce="model => model.model"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                taggable
                required
                label="model"
                :options="dropdownModel"
                placeholder="เลือกรุ่นอุปกรณ์..."
                transition=""
                :disabled="disabledModel"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="ชื่อกล้อง(รายละเอียดมุ่งหน้าทิศทางไหน)"
          >
            <validation-provider
              #default="{ errors }"
              name="hostname"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="hostname"
                  v-model="editData.hostname"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="ชื่ออุปกรณ์"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="SERIAL"
          >
            <validation-provider
              #default="{ errors }"
              name="serial"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="serial"
                  v-model="editData.serial"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="serial"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- username -->
        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="ชื่อผู้ใช้งานอุปกรณ์"
            label-for="username"
          >
            <validation-provider
              #default="{ errors }"
              name="username"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="username"
                  v-model="editData.username"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="ไม่เกิน 20 ตัวอักษร (ชื่อผู้ใช้งานอุปกรณ์)"
                  maxlength="20"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- password -->
        <!-- <b-col
          md="12"
          lg="6"
        >
          <b-form-group
            label="รหัสผ่านอุปกรณ์"
            label-for="passwd"
          >
            <validation-provider
              #default="{ errors }"
              name="passwd"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="passwd"
                  v-model="editData.passwd"
                  type="password"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="รหัสผ่านอุปกรณ์"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <b-col
          md="12"
          lg="3"
        >
          <b-form-group
            label="Latitude "
          >
            <validation-provider
              #default="{ errors }"
              name="latitude"
              rules="required|latitude"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="latitude"
                  v-model="editData.latitude"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="ละติจูด "
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          lg="3"
        >
          <b-form-group
            label="Longitude"
          >
            <validation-provider
              #default="{ errors }"
              name="longitude"
              rules="required|longitude"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="longitude"
                  v-model="editData.longitude"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="ลองจิจูด"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="6"
          lg="6"
        >
          <b-form-group
            label="URL RTSP (.m3u8)"
          >
            <validation-provider
              #default="{ errors }"
              name="URL RTSP"
              rules="required|URL_RTSP"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="hls_url"
                  v-model="editData.hls_url"
                  type="text"
                  placeholder="https://example.com/stream.m3u8"
                  :state="errors.length > 0 ? false:null"
                  required
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          md="12"
          lg="3"
        >
          <b-form-group
            label="กม. (1+xxx)"
          >
            <validation-provider
              #default="{ errors }"
              name="sta"
              rules="required|sta"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="sta"
                  v-model="editData.sta"
                  type="text"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="STA"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          md="12"
          lg="9"
        >
          <b-form-group
            label="หมายเหตุ"
          >
            <b-input-group class="input-group-merge">
              <b-form-textarea
                id="note"
                v-model="editData.note"
                type="text"
                placeholder="Note"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    idData: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      required,
      dropdownLocation: [],
      editData: {
        // ไม่โชว์
        pj_code: '',
        location: '',
        location_id: '',
        // โชว์
        hostname: '',
        ipaddress: '',
        note: '',
        sta: '',
        hls_url: '',
        latitude: '',
        longitude: '',
      },
    }
  },
  mounted() {
    this.getLocation()
  },
  methods: {
    sendInfo(ip) {
      this.editData.ipaddress = ip
      axios
        .post('/fetchCCTV', { ipaddress: ip })
        .then(response => {
          // โชว์
          this.editData.hostname = response.data.hostname
          this.editData.ipaddress = response.data.ipaddress
          this.editData.note = response.data.note
          this.editData.sta = response.data.sta
          this.editData.hls_url = response.data.hls_url
          this.editData.latitude = response.data.latitude
          this.editData.longitude = response.data.longitude
          console.log(this.editData)
        })
        .catch(error => {
          console.log(error)
        })
    },
    // แก้ไขข้อมูลผู้ใช้ในModal
    editInfo() {
      axios
        .post('/editEquipment', this.editData)
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">แก้ไขข้อมูลเรียบร้อย.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.resetModal()
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetModal() {
      this.editData.location = ''
      this.editData.deptid = ''
      this.editData.location_id = ''

      // โชว์
      this.editData.latitude = ''
      this.editData.longitude = ''
      this.editData.desc = ''
      this.editData.ipaddress = ''
      this.editData.note = ''
      this.editData.sta = ''
      this.editData.hls_url = ''
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          // eslint-disable-next-line
          return
        }
        this.editInfo()
        this.$nextTick(() => {
          this.$bvModal.hide(`EquipmentEdit${this.idData}`)
        })
      })
    },
    getLocation() {
      axios
        .post('/locationMenu', { pj_code: this.$route.query.pj_code })
        .then(response => {
          this.dropdownLocation = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.modal .modal-huge {
  max-width: 1000px;
  width: 1000px;
}
</style>
